export default __webpack_public_path__ + "static/media/Gallery16.8f4a42be.jpg";